/*
 * Public API Surface of ang-music-player
 */

export * from './lib/serives/ang-music-player.service';
export * from './lib/component/ang-music-player.component';
export * from './lib/ang-music-player.module';
